import { z } from 'zod';
import { CbaPackagePayment } from '@pages/Cba';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/cba/payment')({
  component: CbaPackagePayment,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
